<template>
  <div id="page-applicant-edit">
    <vs-alert
      color="danger"
      title="Bewerber nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Bewerber mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'applicant.overview' }"
          class="text-inherit underline"
          >Alle Bewerber</router-link
        >
      </span>
    </vs-alert>
    <template v-if="$store.getters['user/hasPermission']('cv_parsing')">
      <vs-alert
        color="danger"
        title="Bewerberdaten werden übertragen"
        :active.sync="cvTransferInProgress"
      >
        <span
          >Eine datei wurde erfolgreich analysiert und wird nun übertragen.
          Bitte verlassen Sie die Seite nicht</span
        >
      </vs-alert>
      <vs-alert
        title="Lebenslauf wird analysiert"
        :active.sync="cvAnalysisInProgress"
      >
        <span
          >Ein Lebenslauf wird analysiert. Sie werden benachrichtigt, sobald die
          Analyse Abgeschlossen ist.</span
        >
      </vs-alert>
    </template>

    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content">
        <div class="vx-card__body">
          <p>Profil Auswahl</p>
          <DataInput
            v-if="applicant"
            v-model="currentProfileId"
            type="select"
            select-label="title"
            :reduce="el => el.id"
            :options="applicant.profiles"
          />
        </div>
      </div>
    </div>
    <vx-card v-if="applicant" class="shadow-none">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <button class="goBack-btn" @click="goBack">
            <i class="fal fa-arrow-left"></i>Zurück
          </button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div class="applicant-name text-2xl">
            #{{ applicant.number }}
            <span>
              <template v-if="applicant.salutation == `MR`">Herr</template>
              <template v-else-if="applicant.salutation == `MRS`"
                >Frau</template
              >
              <template v-else>-</template>
            </span>
            - {{ applicant.firstName }} {{ applicant.lastName }}
            <template v-if="!applicant.privacyPolicyAccepted">
              <i
                class="fas fa-exclamation-triangle"
                title="Datenschutzerklärung fehlt!"
                style="color: red; font-size: 16px"
              ></i>
            </template>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2 text-right">
          <select
            id="template"
            name="template"
            class="mr-2"
            @change="templateChange()"
          >
            <option value="Profil-AUE">PDF Profil (AÜ)</option>
            <option value="Profil-PV">PDF Profil (PV)</option>
          </select>
          <button class="mr-2 export-btn" @click="downloadPdf">PDF</button>
          <button class="mr-2 export-btn" @click="applicantDataForm">
            Bewerberbogen
          </button>
          <button class="mr-2 export-btn" @click="applicantSkillForm">
            Skillbogen
          </button>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="applicant" class="shadow-none">
      <div
        v-if="currentProfileId"
        slot="no-body"
        class="tabs-container px-6 pt-6"
      >
        <vs-tabs v-model="currentTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Persönliche Daten" icon-pack="fas" icon="fa-user">
            <div v-if="tabs[currentTab] === 'data'" class="tab-text">
              <PersonalData :profile-id="currentProfileId" @saved="formSaved" />
            </div>
          </vs-tab>
          <vs-tab
            label="Bewerbung als"
            icon-pack="fal"
            icon="fa-user-astronaut"
          >
            <div v-if="tabs[currentTab] === 'profile'" class="tab-text">
              <ApplicationAs
                :profile-id="currentProfileId"
                @saved="formSaved"
              />
            </div>
          </vs-tab>
          <vs-tab label="Lebenslauf" icon-pack="far" icon="fa-file-user">
            <div v-if="tabs[currentTab] === 'cv'" class="tab-text">
              <CV :profile-id="currentProfileId" />
            </div>
          </vs-tab>
          <vs-tab label="Dokumente" icon-pack="far" icon="fa-file-alt">
            <div v-if="tabs[currentTab] === 'docs'" class="tab-text">
              <Documents
                :profile-id="currentProfileId"
                @cv-analysis-complete="updateApplicantFromCV"
                @cv-analysis-started="
                  x => {
                    cvAnalysisInProgress = x;
                  }
                "
              />
            </div>
          </vs-tab>
          <vs-tab label="Intern" icon-pack="far" icon="fa-unlock">
            <div v-if="tabs[currentTab] === 'internal'" class="tab-text">
              <InternalData :profile-id="currentProfileId" @saved="formSaved" />
            </div>
          </vs-tab>
          <vs-tab label="Wiedervorlagen" icon-pack="far" icon="fa-repeat">
            <div v-if="tabs[currentTab] === 'resubmission'" class="tab-text">
              <Resubmissions :profile-id="currentProfileId" />
            </div>
          </vs-tab>
          <vs-tab label="Intern - Historie" icon-pack="far" icon="fa-history">
            <div v-if="tabs[currentTab] === 'history'" class="tab-text">
              <InternalHistory :profile-id="currentProfileId" />
            </div>
          </vs-tab>
          <vs-tab label="Intern - Profil" icon-pack="far" icon="fa-user-unlock">
            <div
              v-if="tabs[currentTab] === 'internal-profile'"
              class="tab-text"
            >
              <InternalProfile
                :profile-id="currentProfileId"
                @saved="formSaved"
              />
            </div>
          </vs-tab>
          <vs-tab label="Kenntnisse" icon-pack="fad" icon="fa-brain">
            <div v-if="tabs[currentTab] === 'knowledge'" class="tab-text">
              <Knowledge :profile-id="currentProfileId" @saved="formSaved" />
            </div>
          </vs-tab>
          <!--
          <vs-tab label="Sonstige Kenntnisse" icon-pack="fad" icon="fa-brain">
            <div
              v-if="tabs[currentTab] === 'additional-knowledge'"
              class="tab-text"
            >
              <KnowledgeAdditional :profile-id="currentProfileId" />
            </div>
          </vs-tab>
          -->
          <vs-tab label="L1" icon-pack="fas" icon="fa-user">
            <div v-if="tabs[currentTab] === 'l1'" class="tab-text">
              <L1 />
            </div>
          </vs-tab>
          <vs-tab
            v-if="$store.getters['user/hasPermission']('bi')"
            label="Daten Synchronisieren"
            icon-pack="fas"
            icon="fa-sync"
          >
            <applicant-data-sync :applicant-id="applicant.id" />
          </vs-tab>
        </vs-tabs>
      </div>
      <router-link
        v-if="applicant.contactData.telephoneMobile"
        id="quick-sms"
        :to="{
          name: 'applicant.shortMessager',
          params: { id: $route.params.id }
        }"
      >
        <i class="fas fa-sms"></i>
      </router-link>
      <router-link
        id="quick-mail"
        :to="{ name: 'applicant.mailer', params: { id: $route.params.id } }"
      >
        <i class="fa fa-envelope"></i>
      </router-link>
      <div v-if="lastSave" class="text-right last-saved pr-5 pl-5">
        <vs-icon class="text-success" icon="fa-check-circle" icon-pack="far" />
        Zuletzt gespeichert: {{ $d(lastSave, "long-secounds") }}
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import ApplicationAs from "./ApplicantEditApplicationAs";
import CV from "./ApplicantEditCV";
import Documents from "./ApplicantEditDocuments";
import editFormMixin from "@/mixins/editFormMixin.js";
import moment from "moment";

import InternalData from "./ApplicantEditInternalData";
import InternalHistory from "./ApplicantEditInternalHistory";
import InternalProfile from "./ApplicantEditInternalProfile";
import Knowledge from "./ApplicantEditKnowledge";
// import KnowledgeAdditional from "./ApplicantEditKnowledgeAdditional";
import L1 from "./ApplicantL1";
import PersonalData from "./ApplicantEditPersonalData";
import Resubmissions from "./ApplicantEditResubmissions";
import gql from "graphql-tag";
import PdfExport from "../pdf";
import ApplicantDataSync from "./ApplicantDataSync.vue";
import debug from "../../../helpers/debug";
import CountriesISO from "../../../data/other/CountriesISO";
import CivilStatus from "../../../data/enums/CivilStatus.js";
import Countries from "@/data/other/Countries.js";

export default {
  components: {
    DataInput,
    ApplicationAs,
    CV,
    Documents,
    InternalData,
    InternalHistory,
    InternalProfile,
    Knowledge,
    // KnowledgeAdditional,
    L1,
    PersonalData,
    Resubmissions,
    ApplicantDataSync
  },
  mixins: [
    editFormMixin({
      methodSuffix: "Applicant",
      idFields: ["entryType", "group"],
      ignoredFields: ["user", "privacyPolicyRequestedDate"],
      legacyIDFields: ["source"]
    })
  ],
  data() {
    document.setDebugCookie = value =>
      debug.setCookie("promatch_debug_mode", value, 100);
    return {
      lastSave: new Date(),
      fetchFailed: false,
      currentTab: 0,
      selectedProfile: null,
      template: "Profil-AUE",
      tabs: [
        "data",
        "profile",
        "cv",
        "docs",
        "internal",
        "resubmission",
        "history",
        "internal-profile",
        "knowledge",
        // "additional-knowledge",
        "l1"
      ],
      cvAnalysisInProgress: false,
      cvTransferInProgress: false
    };
  },

  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            number
            salutation
            firstName
            lastName
            birthday
            birthplace
            privacyPolicyAccepted
            kids
            civilStatus
            nationality
            defaultProfile {
              id
              wantedOccupation
              skillJobType {
                id
              }
            }
            contactData {
              email
              telephone
              telephoneMobile
              address {
                street
                zip
                city
              }
            }
            source {
              id
              name
            }
            profiles {
              id
              title
              isDefault
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    }
  },
  computed: {
    currentProfileId: {
      get() {
        if (!this.applicant || !this.applicant.profiles) return;
        if (this.selectedProfile) return this.selectedProfile;

        //console.log(this.applicant.profiles);
        const profile = this.applicant.profiles.find(v => v.isDefault);

        return profile ? profile.id : null;
      },
      set(v) {
        //console.log(v);
        this.selectedProfile = v;
      }
    }
  },
  watch: {
    currentTab(tab) {
      if (this.$route.params.page !== this.tabs[tab]) {
        this.$router.replace({
          name: "applicant.edit.sub",
          params: { page: this.tabs[tab] }
        });
      }
    },
    "applicant.profiles": function() {
      //console.log(value);
    }
  },
  mounted() {
    if (this.$route.params.page) {
      this.currentTab = this.tabs.indexOf(this.$route.params.page);
    }
  },
  beforeCreate() {
    this.$router.replace({
      name: "applicant.show",
      params: { id: this.$route.params.id }
    });
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    },
    async updateApplicantFromCV(cvData) {
      let $this = this;
      if (!this.$store.getters["user/hasPermission"]("cv_parsing")) {
        return;
      }
      const documentID = cvData.documentID;
      this.cvTransferInProgress = true;
      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };
      let notParseable = "";
      const cvEntryTypes = await this.$apollo
        .query({
          query: gql`
            {
              applicantCvEntryTypes(page: 1, size: 100) {
                results {
                  id
                  name
                }
              }
            }
          `
        })
        .then(({ data }) => {
          //console.log(data);
          return Object.fromEntries(
            data.applicantCvEntryTypes.results.map(x => [x.name, x.id])
          );
        });
      const applicantSources = await this.$apollo
        .query({
          query: gql`
            {
              applicantSources(page: 1, size: 1000) {
                results {
                  id
                  name
                }
              }
            }
          `
        })
        .then(({ data }) =>
          Object.fromEntries(
            data.applicantSources.results.map(x => [x.nam, x.id])
          )
        );
      function getValueAt(obj, key) {
        //console.log(obj, key);
        let keyArray = key
          .split(".")
          .map(x => x.split("[").map(y => y.replace("[", "")))
          .flat(3)
          .map(str => {
            if (!isNaN(str) && !isNaN(parseFloat(str))) {
              return parseInt(str);
            } else {
              return str;
            }
          });
        //console.log(keyArray);
        try {
          let current = obj;
          for (let k of keyArray) {
            current = current[k];
          }
          //console.log(current);
          return current;
        } catch {
          //console.log(obj, key);
          return null;
        }
      }
      function tryDo(func) {
        try {
          return func();
        } catch (err) {
          console.log("Warning: problem updating objects: ", err); //eslint-ignore-line
        }
      }
      async function newApplicantData(cvData) {
        //console.log(cvData);
        notParseable += [
          "",
          ...[cvData.CustomArea, cvData.Hobbies, cvData.skills].map(x =>
            JSON.stringify(x)
          )
        ];
        return {
          firstName:
            (getValueAt(cvData, "personal.firstName") || "") +
            (getValueAt(cvData, "personal.middleName")
              ? " " + getValueAt(cvData, "personal.middleName")
              : ""),
          lastName: getValueAt(cvData, "personal.lastName"),
          birthday: moment(getValueAt(cvData, "personal.birthDate")),
          salutation: tryDo(() => {
            const genderDescription = getValueAt(
              cvData,
              "personal.gender.description"
            );
            if (genderDescription == "Male") {
              return "MR";
            } else if (genderDescription == "Female") {
              return "MRS";
            } else {
              return undefined;
            }
          }),
          contactData: {
            email:
              tryDo(
                () =>
                  (getValueAt(cvData, "personal.emails") || []).map(
                    x => x.email
                  )[0]
              ) || null,
            telephone: tryDo(() => {
              for (const phone of getValueAt(cvData, "personal.phones") || []) {
                if (phone.type == "home") {
                  return phone.number;
                }
              }
            }),
            telephoneMobile: tryDo(() => {
              for (const phone of getValueAt(cvData, "personal.phones") || []) {
                if (phone.type == "mobile") {
                  return phone.number;
                }
              }
            }),
            address: {
              street:
                getValueAt(cvData, "personal.address.street") +
                " " +
                getValueAt(cvData, "personal.address.number"),
              city: getValueAt(cvData, "personal.address.city"),
              zip: getValueAt(cvData, "personal.address.postalCode"),
              country: tryDo(() => {
                const countryCode = getValueAt(
                  cvData,
                  "personal.address.country.code"
                );
                return CountriesISO.find(function(val) {
                  return val.ISO2 == countryCode;
                }).internalCode;
              }),
              lat: Number(getValueAt(cvData, "personal.address.latitude")),
              lng: Number(getValueAt(cvData, "personal.address.longitude"))
            }
          },
          nationality: getValueAt(cvData, "nationality.code"),
          imageID: await tryDo(async () => {
            if (cvData.profilePicture && cvData.profilePicture.base64Content) {
              let formData = new FormData();
              const file = b64toBlob(
                cvData.profilePicture.base64Content,
                cvData.profilePicture.contentType
              );
              formData.append("file", file, cvData.profilePicture.fileName);
              formData.append("is_public", true);
              try {
                const response = await $this.$axiosStorageApi.post(
                  "/file/upload_auth",
                  formData
                );
                return response.id;
              } catch {
                notParseable += "\nProfilbild";
              }
            }
          })
        };
      }
      function newApplicantProfile(cvData, cvEntries) {
        return {
          cvEntries: tryDo(() => {
            if (!cvEntries) {
              cvEntries = [];
            }
            let latestEndDate = null;
            function setLatestEndDate(newDate) {
              if (!latestEndDate) {
                latestEndDate = newDate;
                return;
              }
              latestEndDate = latestEndDate > newDate ? latestEndDate : newDate;
            }
            for (const degree of getValueAt(
              cvData,
              "educationHistory.degrees"
            ) || []) {
              cvEntries.push({
                type:
                  cvEntryTypes[
                    {
                      "Secondary Education": "Schule",
                      "Primary Education": "Schule",
                      "Vocational Education": "Ausbildung"
                    }[degree.internationalDescription] || "Studium"
                  ],
                applicant: $this.$route.params.id,
                dateFrom: degree.startDate,
                dateUntil: degree.endDate,
                employer: (degree.institute + " " + degree.location).trim(),
                position: degree.degreeName
              });
              setLatestEndDate(degree.endDate);
            }
            for (const course of cvData.courses || []) {
              cvEntries.push({
                type: cvEntryTypes["Weiterbildung"],
                position: course.courseName,
                dateUntil: course.endDate,
                dateFrom: course.startDate,
                employer: (course.institute + " " + course.location).trim(),
                applicant: $this.$route.params.id
              });
              setLatestEndDate(course.endDate);
            }
            //console.log(cvEntryTypes);
            for (const employment of cvData.employmentHistory || []) {
              let type = cvEntryTypes["Berufserfahrung"];
              if (employment.jobTitle == "Zivildienst") {
                type = cvEntryTypes["Bundeswehr / Zivildienst"];
              }
              cvEntries.push({
                type,
                dateUntil: employment.endDate,
                dateFrom: employment.startDate,
                employer: (
                  employment.organization +
                  " " +
                  employment.location
                ).trim(),
                applicant: $this.$route.params.id,
                position: employment.jobTitle,
                description: employment.description
              });
              setLatestEndDate(employment.endDate);
            }
            if (cvData.summary.currentJob) {
              let currentJobSet = false;
              for (let cvEntry of cvEntries) {
                if (
                  !cvEntry.id &&
                  cvEntry.dateUntil == latestEndDate &&
                  cvEntry.position == cvData.summary.currentJob
                ) {
                  cvEntry.dateUntil = null;
                  //cvEntry.currentJob = true;
                  currentJobSet = true;
                  break;
                }
              }
              if (!currentJobSet) {
                notParseable += `\nDerzeitiger Job: ${cvData.summary.currentJob}\nDerzeitiger Arbeitgeber: ${cvData.summary.currentEmployer}`;
              }
            }
            return cvEntries;
          })
        };
      }
      //console.log(JSON.stringify(this.applicant));
      let applicantCopy = JSON.parse(JSON.stringify(await this.applicant));
      let applicantData = await newApplicantData(cvData);
      applicantCopy.contactData.address = Object.assign(
        applicantData.contactData.address,
        applicantCopy.contactData.address
      );
      applicantCopy.contactData.email =
        applicantCopy.contactData.email || applicantData.contactData.email;
      applicantCopy.contactData.telephone =
        applicantCopy.contactData.telephone ||
        applicantData.contactData.telephone;
      applicantCopy.contactData.telephoneMobile =
        applicantCopy.contactData.telephoneMobile ||
        applicantData.contactData.telephoneMobile;
      console.log(applicantData.contactData, applicantCopy.contactData);
      applicantCopy.contactData = Object.assign(
        applicantData.contactData,
        applicantCopy.contactData
      );
      let applicantUpdate = Object.assign(applicantData, applicantCopy);
      applicantUpdate.profiles[0].cvEntries = await newApplicantProfile(
        cvData,
        applicantUpdate.profiles[0].cvEntries
      ).cvEntries;
      //console.log(applicantUpdate);
      async function addEntry(input, profileId) {
        input.applicantProfileID = profileId;

        await $this.$apollo.mutate({
          mutation: gql`
            mutation($input: CvEntryInput!) {
              createCvEntry(input: $input) {
                id
              }
            }
          `,
          variables: {
            input
          }
        });
      }
      applicantUpdate.profiles[0].internalRatingComment +=
        "<p> <strong>Folgende Daten konnten nicht verarbeitet werden</strong> <br />" +
        notParseable +
        "</p>";
      async function persist(input) {
        let profileId = input.profiles[0].id;
        let profile = Object.prepareGqlInput(input.profiles[0]);
        delete profile["cvEntries"];
        await $this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantProfileInput!) {
                updateApplicantProfile(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: profileId,
              input: profile
            }
          })
          .catch(error => {
            $this.reportUnhandledErrorApplicant(error);
            throw error;
          });

        let id = input.id;
        input = Object.prepareGqlInput(input);
        delete input["profiles"];
        delete input["defaultProfile"];
        delete input["number"];
        input.source = applicantSources[input.source] || null;
        await $this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantInput!) {
                updateApplicant(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id,
              input
            }
          })
          .then(() => {
            $this.$vs.notify({
              title: "Bewerberdaten aus datei übertragen",
              text:
                "Daten, die nicht verarbeitet werden konntnen finden Sie unter internes in der Bewertung",
              color: "success",
              icon: "query_builder",
              position: "bottom-center"
            });
          })
          .catch(error => {
            $this.reportUnhandledErrorApplicant(error);
          });
      }
      await (async () => {
        //console.log(applicantUpdate);
        for (let cvEntry of applicantUpdate.profiles[0].cvEntries) {
          if (!cvEntry.id) {
            await addEntry(cvEntry, applicantUpdate.profiles[0].id);
          }
        }
      })();
      await persist(applicantUpdate);

      this.cvTransferInProgress = false;
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!) {
              sortCvEntries(profile: $id)
            }
          `,
          variables: {
            id: applicantUpdate.profiles[0].id
          }
        });
      } catch (e) {
        $this.reportUnhandledErrorApplicant(e);
      }
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            completeDocumentAnalysis(id: $id)
          }
        `,
        variables: {
          id: documentID
        }
      });
      window.location.reload();
    },
    templateChange() {
      var e = document.getElementById("template");
      this.template = e.value;
    },
    async applicantDataForm() {
      await this.$apollo.queries.applicant.refetch();
      let wantedOccupation = "";
      let street = "";
      let zip = "";
      let city = "";
      let email = "";
      let phone = "";
      let mobile = "";
      let birthday = "";
      let birthplace = "";
      let salutation = "";
      let kids = "";
      let civilStatus = "";
      let nationality = "";

      if (this.applicant.defaultProfile.wantedOccupation) {
        wantedOccupation = this.applicant.defaultProfile.wantedOccupation;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.street
      ) {
        street = this.applicant.contactData.address.street;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.zip
      ) {
        zip = this.applicant.contactData.address.zip;
      }
      if (
        this.applicant.contactData.address &&
        this.applicant.contactData.address.city
      ) {
        city = this.applicant.contactData.address.city;
      }
      if (this.applicant.contactData.email) {
        email = this.applicant.contactData.email;
      }
      if (this.applicant.contactData.telephone) {
        phone = this.applicant.contactData.telephone;
      }
      if (this.applicant.contactData.telephoneMobile) {
        mobile = this.applicant.contactData.telephoneMobile;
      }
      if (this.applicant.birthday) {
        birthday = this.applicant.birthday;
      }
      if (this.applicant.birthplace) {
        birthplace = this.applicant.birthplace;
      }
      if (this.applicant.salutation) {
        salutation = this.applicant.salutation;
      }
      if (this.applicant.kids) {
        kids = this.applicant.kids;
      }
      if (this.applicant.civilStatus) {
        civilStatus = CivilStatus[this.applicant.civilStatus];
      }
      if (this.applicant.nationality) {
        let $this = this;
        nationality = Countries.filter(function(elem) {
          return elem.code == $this.applicant.nationality;
        })[0].label;
      }
      window.location =
        "https://select-gmbh.de/applicant/pdf/data?job=" +
        wantedOccupation +
        "&firstName=" +
        this.applicant.firstName +
        "&lastName=" +
        this.applicant.lastName +
        "&street=" +
        street +
        "&zip=" +
        zip +
        "&city=" +
        city +
        "&email=" +
        email +
        "&phone=" +
        phone +
        "&mobile=" +
        mobile +
        "&birthday=" +
        birthday +
        "&birthplace=" +
        birthplace +
        "&salutation=" +
        salutation +
        "&kids=" +
        kids +
        "&civilStatus=" +
        civilStatus +
        "&nationality=" +
        nationality;
    },
    async applicantSkillForm() {
      const profileData = (
        await this.$apollo.query({
          query: gql`
            query ApplicantProfile($id: ID!) {
              applicantProfile(id: $id) {
                id
                skillJobType {
                  id
                }
              }
            }
          `,
          fetchPolicy: "network-only",
          variables: {
            id: this.applicant.defaultProfile.id
          }
        })
      ).data.applicantProfile;

      if (profileData.skillJobType) {
        window.location =
          "https://select-gmbh.de/applicant/pdf/skills?jobtype=" +
          profileData.skillJobType.id;
      } else {
        this.$vs.notify({
          title: "Skillbogen drucken",
          text: "Bitte Berufsbereich hinterlegen!",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center"
        });
      }
    },
    formSaved(e) {
      this.$vs.notify({
        title: "Bewerber gespeichert",
        text: "Bewerber wurde erfolgreich gespeichert",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });

      this.lastSave = e;
    },
    async downloadPdf() {
      const applicantData = await this.$apollo.query({
        query: gql`
          query Applicant($id: ID!) {
            applicant(id: $id) {
              id
              number
              salutation
              firstName
              lastName
              civilStatus
              imageID
              birthday
              contactData {
                address {
                  city
                }
              }
              group {
                id
                name
              }
              source {
                id
                name
              }
              entryType {
                id
                name
              }
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          id: this.$route.params.id
        }
      });

      const profileData = await this.$apollo.query({
        query: gql`
          query ApplicantProfile($id: ID!) {
            applicantProfile(id: $id) {
              id
              shortProfileDescription
              showPicture
              exportGender
              exportName
              exportAdress
              exportShortDescription
              exportInternalRating
              exportNegotioation
              exportNameMasking
              internalRatingComment
              wantedOccupation
              mobilityComment
              availibilty {
                id
                name
              }
              availibiltyCustom
              ownCar
              driverLicenses {
                id
                name
              }
              consultant {
                id
                firstName
                lastName
                telephone
                fax
                imageID
                user {
                  id
                  email
                }
              }
              cvEntries {
                id
                type {
                  id
                  name
                }
                branch {
                  id
                  name
                }
                dateUntil
                dateFrom
                employer
                position
                description
              }
              skillJobType {
                id
              }
              wantedJobTypes {
                id
                name
              }
              commissionAmount
            }
          }
        `,
        fetchPolicy: "network-only",
        variables: {
          id: this.currentProfileId
        }
      });

      PdfExport(
        this.$apollo,
        this.$axiosStorageApi,
        applicantData.data.applicant,
        profileData.data.applicantProfile,
        this.template
      );
    }
  }
};
</script>

<style>
#quick-mail {
  position: fixed;
  right: 20px;
  bottom: 25px;
  display: inline-block;
  width: 45px;
  height: 45px;
  line-height: 42px;
  border-radius: 50%;
  text-align: center;
  background-color: #ff9f43;
  cursor: pointer;
  border: 2px solid #ff9f43;
  transition: 0.3s ease all;
  color: white;
  z-index: 500;
}
#quick-mail:hover {
  background-color: white;
  color: #ff9f43;
}

#quick-sms {
  position: fixed;
  right: 20px;
  bottom: 85px;
  display: inline-block;
  width: 45px;
  height: 45px;
  line-height: 42px;
  border-radius: 50%;
  text-align: center;
  background-color: #ff9f43;
  cursor: pointer;
  border: 2px solid #ff9f43;
  transition: 0.3s ease all;
  color: white;
  z-index: 500;
}

#quick-sms:hover {
  background-color: white;
  color: #ff9f43;
}
</style>
